import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { useDispatch } from "react-redux";
import { getCashFlowCompanyData } from '../../../api/cachFlowTracker';
import { raiseToast } from '../toast/toast';

export const fetchCashFlowCompanyData = createAsyncThunk('company/getCashFlowData', async (params) => {
    const response = await getCashFlowCompanyData()
    if (response.failure) {
        const dispatch = useDispatch()
        return dispatch(raiseToast({ severity: 'error', summary: 'Vendor Payments', detail: response.data.error, life: 3000 }))
    }
    return response.data
})

export const getCashFlowDataSlice = createSlice({
    name: "company/getCashFlowData",
    initialState: {
        loading: false,
        getCashFlowData: [],
    },
    reducers: {
        updateSearchOptions: (state, action) => {
            state.searchOptions = action.payload
        },
        updateSearchParams: (state, action) => {
            state.searchParams = action.payload
        },
        updateCashFlowCompanyData: (state, action) => {
            state.getCashFlowData = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(
            fetchCashFlowCompanyData.fulfilled, (state, action) => {
                state.loading = false
                state.getCashFlowData = action.payload.data
            }
        )
            .addCase(
                fetchCashFlowCompanyData.pending, (state, action) => {
                    state.loading = true
                }
            )
            .addCase(
                fetchCashFlowCompanyData.rejected, (state, action) => {
                    state.loading = false
                }
            )
    }
})

export const { updateSearchParams, updateSearchOptions, updateCashFlowCompanyData } = getCashFlowDataSlice.actions

export default getCashFlowDataSlice.reducer